// extracted by mini-css-extract-plugin
export var deleteModal = "_g9-0";